import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import EditOtherShippingOptions from '../../orders/other-shipping-options/components/edit-component';
import { BULK_UPDATE_FULFILLMENT_PLAN_ID } from '../../orders/other-shipping-options/constants';
import { allCategories as otherShippingOptionsCategories } from '../../services/other-shipping-options/constants';
import DataDrivenLogo from '../data-driven-logo';
import getDisplayInformation from '../data-driven-logo/get-display-information';

import style from './bulk-edit-other-shipping-options.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const BulkEditOtherShippingOptions = ({
  saveOptions,
  optionData = emptyObject,
  hasMultipleCarriers = false,
  labelProviderId = '0',
  sellerLabelProviderId = null,
}) => {
  const providerId = Number.parseInt(labelProviderId, 10);
  const displayInformation = getDisplayInformation({ providerId });
  return (
    <div className={style['bulk-other-shipping-options']}>
      <div className={style.header}>
        {!hasMultipleCarriers && (
          <div className={style.logo}>
            <DataDrivenLogo className={style['header-icon-svg']} logoType='icon' providerId={providerId} />
          </div>
        )}
        <div className={style['header-title']}>
          {hasMultipleCarriers && (
            <FormattedMessage defaultMessage='Available Options' description='bulkEditOtherShippingOptions.availableOptions' id='OFyplt' />
          )}
          {!hasMultipleCarriers && (
            <FormattedMessage
              defaultMessage='{carrierName} Options'
              description='bulkEditOtherShippingOptions.carrierOptions'
              id='dZlAKF'
              values={{ carrierName: displayInformation?.name }}
            />
          )}
        </div>
      </div>
      <div className={style.content}>
        <EditOtherShippingOptions
          fulfillmentPlanId={BULK_UPDATE_FULFILLMENT_PLAN_ID}
          options={optionData}
          saveOptions={saveOptions}
          sectionsToShow={otherShippingOptionsCategories}
          sellerLabelProviderId={sellerLabelProviderId}
        />
      </div>
    </div>
  );
};

BulkEditOtherShippingOptions.propTypes = {
  saveOptions: PropTypes.func.isRequired,
  /*
    this is structured like
    {
      includeReturnLabel: {
        packageTypeId: 3,
        checked: true,
      }
    }
 */
  optionData: PropTypes.object,
  hasMultipleCarriers: PropTypes.bool,
  labelProviderId: PropTypes.string,
  sellerLabelProviderId: PropTypes.string,
};

export default BulkEditOtherShippingOptions;
